<template>
  <standard-layout v-if="season" :only-main="true">
    <template v-slot:heading>
      <div class="d-flex justify-content-between">
        <div>
          <sakali-header :title="'Saison ' + season.period"/>
        </div>
        <div>
          <router-link :class="{'text-secondary': prevSeasonNumberInChallenge < 1,
                       'link': prevSeasonNumberInChallenge > 1,
                       'hover-sakali-primary': prevSeasonNumberInChallenge > 1}"
                       :to="{name:'betSeasonResults', params: {numberInChallenge: prevSeasonNumberInChallenge}}"
                       :is="prevSeasonNumberInChallenge > 1 ? 'router-link' : 'span'">
            <fas icon="chevron-left"
                 size="lg"
                 class="me-3"
                 :class="{'muted':prevSeasonNumberInChallenge < 1}">
            </fas>
          </router-link>
          <router-link :class="{'text-secondary': nextSeasonNumberInChallenge < 0,
                       'link': nextSeasonNumberInChallenge > 0,
                       'hover-sakali-primary': nextSeasonNumberInChallenge > 0}"
                       :to="{name:'betSeasonResults', params: {numberInChallenge: nextSeasonNumberInChallenge}}"
                       :is="nextSeasonNumberInChallenge > 0 ? 'router-link' : 'span'">
            <fas icon="chevron-right"
                 size="lg"
                 class="me-3">
            </fas>
          </router-link>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="leagueOnlySwitch" @change="leagueOnly = !leagueOnly">
            <label class="form-check-label" for="leagueOnlySwitch">nur meine Liga</label>
          </div>
          <div class="form-check form-switch ms-2">
            <input class="form-check-input" type="checkbox" id="friendsOnlySwitch" @change="friendsOnly = !friendsOnly">
            <label class="form-check-label" for="friendsOnlySwitch">nur Freunde</label>
          </div>
        </div>
        <nav aria-label="Navigation der Liste"
             class="d-flex justify-content-end"
             v-if="betSeasonRankings.length > 0">
          <ul class="pagination">
            <li class="page-item page-link"
                @click="prevPage">
              <fas icon="caret-left"
                   :class="{'muted':page === 0}"/>
            </li>
            <li class="page-item page-link"
                @click="nextPage">
              <fas icon="caret-right"/>
            </li>
          </ul>
        </nav>
      </div>
      <ul class="list-group" v-if="betSeasonRankings.length > 0">
        <li v-for="(betSeasonRank, idx) in betSeasonRankings"
            :key="betSeasonRank.user.id"
            class="list-group-item d-flex justify-content-between"
            :class="{'odd': idx % 2 === 1, 'list-group-item-highlight': betSeasonRank.user.id === userId}">
          <div class="d-flex">
            <div class="d-flex justify-content-end rank-number mt-1">
              <div
                  v-if="betSeasonRank.rank > 0 && (idx === 0 || (betSeasonRank.rank === (page * elementsPerPage) + idx + 1))">
                {{ betSeasonRank.rank }}.
              </div>
            </div>
            <div class="ms-2 d-flex">
              <div class="align-items-center">
                <sakali-user :user="betSeasonRank.user"/>
              </div>
            </div>
          </div>
          <div class="points">
            {{ betSeasonRank.points | float }}
          </div>
        </li>
      </ul>
      <div v-else class="text-center mt-4">
        Es wurden aktuell noch keine Tipps abgegeben
      </div>
    </template>
  </standard-layout>
</template>

<script>
import sakaliApi from "../sakali-api";
import {mapActions, mapGetters} from 'vuex'

import StandardLayout from "@/layouts/StandardLayout.vue";

export default {
  props: {
    numberInChallenge: [String, Number]
  },
  data() {
    return {
      page: -1,
      elementsPerPage: 20,
      season: null,
      betSeasonRankings: [],
      leagueOnly: false,
      friendsOnly: false
    }
  },
  computed: {
    ...mapGetters(['userId']),
    totalPages() {
      return 1000; // todo
    },
    prevSeasonNumberInChallenge() {
      return this.numberInChallenge > 1 ? this.numberInChallenge - 1 : 1
    },
    nextSeasonNumberInChallenge() {
      return this.season.finished ? +this.numberInChallenge + 1 : -1
    }
  },
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    loadSeason() {
      let numberInChallenge = this.numberInChallenge
      if (!numberInChallenge) {
        sakaliApi.get('/seasons/current').then(response => {
          this.$router.push({name: 'betSeasonResults', params: {numberInChallenge: response.data.numberInChallenge}})
        }).catch(err => this.handleError(err))
      } else {
        sakaliApi.get(`/seasons/main-by-number/${numberInChallenge}`)
            .then(response => {
              this.season = response.data
            })
            .catch(error => {
              this.handleErrorAction(error)
            })
      }
    },
    loadRankings() {
      sakaliApi.get(`/betseasonranking/${this.season.id}`, {
        params: {
          c: false,
          p: this.page,
          e: this.elementsPerPage,
          f: (this.leagueOnly ? 'lo' : '') + (this.friendsOnly ? 'fo' : '')
        }
      }).then(res => {
        const newRankings = res.data
        if (newRankings.length > 0) {
          this.betSeasonRankings = newRankings
          if (this.page === -1)
            this.page = Math.floor(this.betSeasonRankings[0].listIndex / this.elementsPerPage)
        } else {
          this.betSeasonRankings = []
        }
      }).catch(error => this.handleError(error))
    },
    nextPage() {
      this.page++
      this.loadRankings()
    },
    prevPage() {
      this.page = this.page > 0 ? this.page - 1 : 0
      this.loadRankings()
    }
  },
  watch: {
    numberInChallenge: {
      handler() {
        this.page = -1
        this.loadSeason()
      },
      immediate: true
    },
    season(newVal) {
      if (newVal)
        this.loadRankings()
    },
    leagueOnly() {
      this.page = -1
      this.loadRankings()
    },
    friendsOnly() {
      this.page = -1
      this.loadRankings()
    }
  },
  components: {
    StandardLayout
  }
}
</script>

<style>
.rank-number {
  width: 0.75em;
  min-width: 0.75em;
}

.page-link {
  background-color: #F9FFD7;
  color: #85A600;
}

.list-group-item-highlight {
  font-weight: bolder;
  color: white;
  background-color: #fda642 !important;
}
</style>